import { observable, action } from 'mobx'
import api from '../api'
import errorStore from './errorStore'

class ContactStore {
    @observable contactName = ''
    @observable contactEmail = ''
    @observable contactMessage = ''
    @observable successfullySentMessage = false

    @action.bound setContactName(contactName) {
      this.contactName = contactName
    }

    @action.bound setContactEmail(contactEmail) {
      this.contactEmail = contactEmail
    }

    @action.bound setContactMessage(contactMessage) {
      this.contactMessage = contactMessage
    }

    @action.bound resetContactStore() {
      this.contactName = ''
      this.contactEmail = ''
      this.contactMessage = ''
      this.successfullySentMessage = false
    }

    @action.bound closeModal() {
      this.resetContactStore()
    }

    @action.bound showModal() {
      this.successfullySentMessage = true
    }

    @action.bound async sendContact() {
      try {
          const res = await api.Contact.postContactRequest({
            'name': this.contactName,
            'email': this.contactEmail,
            'message': this.contactMessage,
          })
          res && this.showModal()
      } catch(error) {
        errorStore.displayError('contact_sent_error')
      }
    }
}

export default new ContactStore()



// WEBPACK FOOTER //
// ./src/stores/contactStore.js